import { Injectable } from "@angular/core";
import { Observable, Subject, config } from "rxjs";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { UtilService } from './util.service';

@Injectable({
  providedIn: "root"
})
export class FormasPagamentoService {

  constructor(private http: HttpClient, private util: UtilService) {

  }

  public buscarFormaPgtoAtual(){

    return this.http
                .get(`${environment.apiURL}/Logado/FormasDePagamento/BuscarFormaPgtoAtual`);
  }

  public BuscarDadosDebito(){

    return this.http
                .get(`${environment.apiURL}/Logado/FormasDePagamento/BuscarDadosDebito`);
  }

  public CPFParticipante(){

    return this.http
                .get(`${environment.apiURL}/Logado/FormasDePagamento/CPFParticipante`);
  }

  public CPFRespFinanceiro(){

    return this.http
                .get(`${environment.apiURL}/Logado/FormasDePagamento/CPFRespFinanceiro`);
  }

  public VerificarCPFRespFinanceiro(cpf: string){

    return this.http
                .get(`${environment.apiURL}/Logado/FormasDePagamento/VerificarCPFRespFinanceiro`, {params: {cpf: cpf}});
  }

  public ListarDiasPgto(codFormaPgto: string){

    return this.http
                .get(`${environment.apiURL}/Logado/FormasDePagamento/ListarDiasPgto`, {params: {codFormaPgto: codFormaPgto}});
  }

  public ListarBancosDebitoConta(){

    return this.http
                .get(`${environment.apiURL}/Logado/FormasDePagamento/ListarBancosDebitoConta`);
  }

  public AlterarFormaPagamento(dados){

    return this.http
                .post(`${environment.apiURL}/Logado/FormasDePagamento/AlterarFormaPagamento`, dados);
  }

}
